let self;

class BasicAuthInterceptor {
    constructor(payseraConfig) {
        self = this;
        this.payseraConfig = payseraConfig;
    }

    request(config) {
        if (!config.headers.Authorization) {
            config.headers.Authorization =
                'Basic '
                + btoa(
                    self.payseraConfig.get('username', 'data-auth')
                    + ':'
                    + self.payseraConfig.get('password', 'data-auth')
                )
            ;
        }

        return config;
    }
}

BasicAuthInterceptor.$inject = ['payseraConfig'];

export default BasicAuthInterceptor;